import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const kensingtonParkConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Kensington Park Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Kensington Park, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_kensington_park',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Kensington Park',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Kensington Park Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we take care of the tree work that protects 
     homes and properties across <strong>Kensington Park</strong>. Older trees with heavy 
     canopies, storm weakened limbs hanging over structures, and overgrowth crowding 
     driveways and fences are all situations our experienced team handles with skill and care. 
     We take on the tough jobs so you don't have to.`,

    `We specialize in <strong>dangerous tree removal and precision trimming</strong> 
     addressing rotted or structurally unsound trunks, limbs threatening rooftops, carports 
     or vehicles, and canopy overgrowth that poses a real storm risk. Our team assesses 
     every situation on site and executes safely without cutting corners.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care throughout 
     <strong>Kensington Park</strong> and across <strong>Sarasota County</strong> 
     giving you a safer property and healthier trees through every season.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Kensington Park, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_KensingtonPark = () => <LocationPage config={kensingtonParkConfig} />;
export default Services_KensingtonPark;
